export default {
    details: "Vous n'êtes pas autorisé à accéder à cette page.",
    goBack: 'Retour à la dernière page',
    goHome: "Aller à l'accueil",
    title: 'Accès non autorisé.',
};
